export enum STUDY_EDIT_FIELD {
  SGL_CODE,
  STATUS,
}
export const STUDY_EDIT_FIELD_NAME = {
  [STUDY_EDIT_FIELD.SGL_CODE]: 'sglCode',
  [STUDY_EDIT_FIELD.STATUS]: 'status',
};
